import type { SalesItemRecord, TireQuoteItemTireRecordCustomer } from '@navio/nsdk';
import { getTirePrice } from 'noddi-util';

/** Gross sum of the selected tires. */
export const getTireOfferTiresTotal = (quoteItemTires: TireQuoteItemTireRecordCustomer[]) =>
  quoteItemTires.reduce(
    (sum, quoteItemTire) => sum + getTirePrice(quoteItemTire).amount * (quoteItemTire.quantitySelected ?? 0),
    0
  );

/** What the customer pays: the selected tires plus the offer's services, gross. */
export const getTireOfferTotal = (quoteItemTires: TireQuoteItemTireRecordCustomer[], genericItems: SalesItemRecord[]) =>
  genericItems.reduce((sum, item) => sum + item.price.priceGross.amount, 0) + getTireOfferTiresTotal(quoteItemTires);
